import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { formatLocalizationResource } from 'helpers/i18n';
import Link from 'components/Link';
import * as selectors from '../../selectors';
const LegalConsentLabel = ({ legalConsent })=>{
    const localizationResources = useSelector(selectors.localizationResources);
    if (!legalConsent) {
        return null;
    }
    const { consentPromptKey, consentUrls } = legalConsent;
    let linkRenderers;
    if (consentUrls) {
        linkRenderers = {};
        for(const consentKey in consentUrls){
            linkRenderers[consentKey] = (_, children)=>/*#__PURE__*/ _jsx(Link, {
                    to: consentUrls[consentKey],
                    target: "_blank",
                    children: children
                });
        }
    }
    return formatLocalizationResource(localizationResources, consentPromptKey, consentUrls, linkRenderers);
};
export default LegalConsentLabel;
